import { NgModule, ApplicationRef } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
/*
 * Platform and Environment providers/directives/pipes
 */
// DatePipe
import { DatePipe } from '@angular/common';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { routing } from './app.routing'
// App is our top level component
import { AppComponent } from './app.component';
import { APP_RESOLVER_PROVIDERS } from './app.resolver';
import { AppState, InternalStateType } from './app.service';

// Core providers
import {CoreModule} from "./core/core.module";
import {SmartadminLayoutModule} from "./shared/layout/layout.module";
import { ConfigService } from './shared/utils/config.service';
import { TokenInterceptor } from './shared/services/token.interceptor';
import { AuthService } from './shared/services/auth.service';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AuthGuard } from './auth.guard';
import { AppenateService } from './shared/services/appenate.service';

import { TuiImageEditorWrapperModule } from 'src/app/shared/dynamic-controls/tui-image-editor-wrapper/tui-image-editor-wrapper.module'

// Application wide providers
const APP_PROVIDERS = [
  ...APP_RESOLVER_PROVIDERS,
  AppState, ConfigService, AuthGuard,AuthService,
  { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true }
];

type StoreType = {
  state: InternalStateType,
  restoreInputValues: () => void,
  disposeOldHosts: () => void
};

import { ToastrModule, ToastContainerModule, ToastContainerDirective, ToastrService } from 'ngx-toastr';

import { AutoLogoutService } from './shared/services/auto-logout.service';
import { AutoLogoutComponent } from './auto-logout/auto-logout.component';

// Common Code
import { AppCode } from './app.code';
import { RouterModule } from '@angular/router';
//import { ClientTasksComponent } from './+admin/client-tasks/Client-tasks.component';
//import { ClientDynamicComponent} from './+admin/client-dynamic/Client-Dynamic.component';
//import { ClientEmailConfigurationComponent } from './+admin/client-email-configuration/Client-Email-Configuration.component';


/**
 * `AppModule` is the main entry point into Angular2's bootstraping process
 */
@NgModule({
  bootstrap: [ AppComponent ],
  declarations: [
    AppComponent,
    AutoLogoutComponent
   
  ],
  imports: [ // import Angular's modules
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    RouterModule,
    ModalModule.forRoot(),
    HttpModule,
    CoreModule,
    SmartadminLayoutModule,
    DateInputsModule,
    routing,
    HttpClientModule,
    ToastrModule.forRoot({
      timeOut: 10000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
    }),
    ToastContainerModule,
    TuiImageEditorWrapperModule
  ],

  providers: [ // expose our Services and Providers into Angular's dependency injection
    // ENV_PROVIDERS,
    APP_PROVIDERS,
    ToastContainerDirective, ToastrService, AutoLogoutService,
    AppCode, DatePipe, AppenateService
  ]
})
export class AppModule {
  constructor(public appRef: ApplicationRef, public appState: AppState) {
  }
}

